export default "__VITE_ASSET__789d6269__"